import _extends from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from "react";
import { Text } from "native-base";
import i18next from "i18next";
var renderText = function renderText(key, defaultValue) {
  return key ? i18next.t(key, {
    defaultValue: "".concat(defaultValue)
  }) : defaultValue;
};
var DPText = function DPText(props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text, props, renderText(i18nKey, children));
};
DPText.Heading1 = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "heading1"
  }, props), renderText(i18nKey, children));
};
DPText.Heading2 = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "heading2"
  }, props), renderText(i18nKey, children));
};
DPText.Heading3 = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "heading3"
  }, props), renderText(i18nKey, children));
};
DPText.HeadingSecondary = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "headingSecondary"
  }, props), renderText(i18nKey, children));
};
DPText.Display = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "display"
  }, props), renderText(i18nKey, children));
};
DPText.Label = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "label",
    fontWeight: "100"
  }, props), renderText(i18nKey, children));
};
DPText.Title = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "title"
  }, props), renderText(i18nKey, children));
};
DPText.PageTitle = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "pagetitle"
  }, props), renderText(i18nKey, children));
};
DPText.SubTitle = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "subTitle"
  }, props), renderText(i18nKey, children));
};
DPText.TextLDark = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "textL_Dark"
  }, props), renderText(i18nKey, children));
};
DPText.TextLLight = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "textL_Light"
  }, props), renderText(i18nKey, children));
};
DPText.TextMDark = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "textM_Dark"
  }, props), renderText(i18nKey, children));
};
DPText.TextMLight = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "textM_Light"
  }, props), renderText(i18nKey, children));
};
DPText.Tooltip = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "tooltip"
  }, props), renderText(i18nKey, children));
};
DPText.Error = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "error"
  }, props), renderText(i18nKey, children));
};
DPText.ButtonL = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "buttonL"
  }, props), renderText(i18nKey, children));
};
DPText.ButtonM = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "buttonM"
  }, props), renderText(i18nKey, children));
};
DPText.Caption = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "caption"
  }, props), renderText(i18nKey, children));
};
DPText.Link = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "link"
  }, props), renderText(i18nKey, children));
};
DPText.HyperLink = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "hyperlink"
  }, props), renderText(i18nKey, children));
};
DPText.RefCode = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "refCode"
  }, props), renderText(i18nKey, children));
};
DPText.AlertInformation = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "alertInformation"
  }, props), renderText(i18nKey, children));
};
DPText.AlertDanger = function (props) {
  var children = props.children,
    i18nKey = props.i18nKey;
  return __jsx(Text
  // @ts-ignore
  , _extends({
    variant: "alertDanger"
  }, props), renderText(i18nKey, children));
};
export default DPText;